(() => {
  if (window.__bkProductBundleReady) return;
  window.__bkProductBundleReady = true;

  const money = (cents) => {
    const value = (parseInt(cents, 10) || 0) / 100;
    try {
      return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(value);
    } catch (error) {
      return value.toFixed(2).replace('.', ',') + ' EUR';
    }
  };

  const activeCard = (root) => root.querySelector('[data-bkpb-card].is-active');
  const activeField = (root) => {
    const card = activeCard(root);
    return card ? card.querySelector('[data-bkpb-variant-select]') : null;
  };
  const activeVariant = (root) => {
    const field = activeField(root);
    return field ? field.value : null;
  };
  const activePrice = (root) => {
    const field = activeField(root);
    if (!field) return 0;
    if (field.options) {
      const option = field.options[field.selectedIndex];
      return parseInt(option && option.getAttribute('data-price'), 10) || 0;
    }
    return parseInt(field.getAttribute('data-price'), 10) || 0;
  };
  const currentProductPrice = (root) => parseInt(root.getAttribute('data-current-price'), 10) || 0;
  const sync = (root) => {
    const card = activeCard(root);
    if (!card) return;
    const titleEl = root.querySelector('[data-bkpb-title]');
    const imageEl = root.querySelector('[data-bkpb-image]');
    const normalEl = root.querySelector('[data-bkpb-normal]');
    const packEl = root.querySelector('[data-bkpb-pack]');
    const saveEl = root.querySelector('[data-bkpb-save]');
    const total = currentProductPrice(root) + activePrice(root);
    const saving = Math.round(total * 0.1);
    const pack = total - saving;
    if (titleEl) titleEl.textContent = card.getAttribute('data-title') || '';
    if (imageEl && card.getAttribute('data-image')) imageEl.src = card.getAttribute('data-image');
    if (normalEl) normalEl.textContent = money(total);
    if (packEl) packEl.textContent = money(pack);
    if (saveEl) saveEl.textContent = 'Poupa ' + money(saving);
  };
  const currentVariant = (root) => {
    const scope = root.closest('product-info') || document;
    const input = scope.querySelector('product-form form [name="id"], form[action*="/cart/add"] [name="id"]') || document.querySelector('product-form form [name="id"], form[action*="/cart/add"] [name="id"]');
    return input && input.value ? input.value : root.getAttribute('data-current-variant');
  };

  const handleClick = (event) => {
    const switchButton = event.target.closest('[data-bkpb-switch]');
    if (switchButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const root = switchButton.closest('[data-bkpb]');
      if (!root) return;
      const key = switchButton.getAttribute('data-bkpb-switch');
      root.querySelectorAll('[data-bkpb-switch]').forEach((button) => button.classList.toggle('is-active', button === switchButton));
      root.querySelectorAll('[data-bkpb-card]').forEach((card) => {
        const active = card.getAttribute('data-bkpb-card') === key;
        card.classList.toggle('is-active', active);
        card.hidden = !active;
      });
      sync(root);
      return;
    }

    const addButton = event.target.closest('[data-bkpb-add]');
    if (!addButton) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const root = addButton.closest('[data-bkpb]');
    if (!root || addButton.disabled) return;

    const productVariant = currentVariant(root);
    const partnerVariant = activeVariant(root);
    if (!productVariant || !partnerVariant) return;

    const original = addButton.textContent;
    addButton.disabled = true;
    addButton.textContent = 'A adicionar...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          { id: Number(productVariant), quantity: 1 },
          { id: Number(partnerVariant), quantity: 1 },
        ],
      }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(() => {
        window.location.href = '/cart';
      })
      .catch(() => {
        addButton.disabled = false;
        addButton.textContent = 'Erro';
        setTimeout(() => {
          addButton.textContent = original;
        }, 1800);
      });
  };

  document.addEventListener('click', handleClick, true);

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-bkpb-variant-select]')) return;
    const root = event.target.closest('[data-bkpb]');
    if (root) sync(root);
  }, true);

  const syncAll = () => document.querySelectorAll('[data-bkpb]').forEach(sync);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }
  document.addEventListener('shopify:section:load', syncAll);
})();
